import Axios from "@/Axios";

class WMSSettingsService{
    
    async addWmsSettings(data){
      return await Axios.post('wms.wms.api.wms_settings.add_wms_setting',data)
    }
    async getWmsSettings(){
        return await Axios.get('wms.wms.api.wms_settings.get_wms_setting')
    }
    async getWmsRoles(){
      return await Axios.get('wms.wms.api.wms_settings.get_wms_roles')
  }

}
export default  new WMSSettingsService()